import PropTypes from "prop-types";
import styles from "./index.css";
import SinglePageAppLink from "../../../../../../../SinglePageAppLink";
import ProductImage from "../../../../../../../ProductImage";
import LazyProductHeroContainer from "../../../../../../../LazyProductHeroContainer";
import { useInView } from "react-intersection-observer";

const ImagePill = ({ friendlyName, linkUrl, imageUrl }) => {
  const { ref, inView } = useInView({ rootMargin: "410px", triggerOnce: true });

  return (
    <li>
      <SinglePageAppLink href={linkUrl} className={styles.wrapper}>
        <LazyProductHeroContainer
          ref={ref}
          doLoad={inView}
          render={props => <ProductImage {...{ image: imageUrl, ...props }} />}
        />
        <p className={styles.title}>{friendlyName}</p>
      </SinglePageAppLink>
    </li>
  );
};

ImagePill.propTypes = {
  friendlyName: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  extraClassName: PropTypes.string
};

export default ImagePill;
